import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { getRuntimeConfig } from '../config/runtimeConfig';

/**
 * AG Grid bootstrap — mirrors `registerLicense` / `initializeSyncfusionAppearance` in `main.tsx`.
 *
 * Enterprise is required for the features the WPF holdings grid exposes: the column tool panel
 * (WPF `GridViewColumnPicker`), row grouping, set filters, aggregation footers and Excel export.
 */
export function initializeAgGrid(): void {
  ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

  const licenseKey = getRuntimeConfig().agGridKey;
  if (licenseKey) {
    LicenseManager.setLicenseKey(licenseKey);
  }
}
